<template>
  <div id="editor-header">
    <div class="panel__header flex">
      <div class="header_nav pointer">
        <span @click="toQrcodeList">二维码管理</span>
        <span class="right-icon">> </span>
        <span class="qrcode_type">{{ getQrcodeType() }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'EditorHeader',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroy() {},
  methods: {
    ...mapMutations(['setRouter']),
    ...mapGetters('editor', ['getQrcodeType']),
    /*
     * 跳转回二维码管理列表
     * */
    toQrcodeList() {
      this.setRouter({ name: 'QRCodeManagement' })
    },
  },
}
</script>
<style lang="scss" scoped>
#editor-header {
  .header_nav {
    font-size: 13px;
    color: #179ae6;
    .qrcode_type {
      color: #222222;
      font-weight: 700;
    }
    .right-icon {
      display: inline-block;
      width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: #cccccc;
    }
  }
}
</style>
<style lang="scss"></style>
